module.exports = __webpack_public_path__ + "static/media/xplogo-header.8ce0cb9f.svg";